

import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import LanguageFlag from "./LanguageFlag";

const LanguageDropdown = ({ defaultValue = "fa", onChange }) => {
const { t, i18n } = useTranslation();
    
  const availableLanguages = Object.keys(i18n.options.resources || {});
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    if (onChange) onChange(value);
  };

  return (
    <div className="mb-3">
      <label className="form-label">  { t('components.languageDropdown.title') }  </label>
      <select
        className="form-select"
        value={selected}
        onChange={handleChange}
      >
        <option value="" disabled> { t('components.languageDropdown.dropdown_label') }   </option>
        {availableLanguages.map((lang) => (
          <option key={lang} value={lang}>
            {lang.toUpperCase()} <LanguageFlag language={lang}/>
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageDropdown;
